module.exports = "/_next/static/images/mr-9c95d54684f154c39969d0bde01dbe74.svg";